var ics = require('./dist');

module.exports = ics;
